import { createSlice } from "@reduxjs/toolkit";
export const masterStateSlice = createSlice({
  name: "masterstate",
  initialState: {
      stateData: [],
    },
    reducers: {
        savestateData: (state, action) => {
            state.stateData = action.payload;
        },
    },
});
export const {savestateData} = masterStateSlice.actions;
export default masterStateSlice.reducer;